import * as React from "react";
import { getQueryParameters, setQueryParameters, setQueryParametersWithoutRefresh } from "../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Navigator } from "../../../../Shared/Wizards/Entities/Navigator";
import { Contents } from "../../../Resoures/Contents";
import { Urls } from "../../../Urls";
import { EditIncomeWithdrawalsAction } from "./Actions/EditIncomeWithdrawalsAction";
import { IncomePaymentDetails } from "./Components/IncomePaymentDetails/IncomePaymentDetails";
import { Review } from "./Components/Review/Review";
import { EditIncomeWithdrawalsSteppersMap, productMap } from "./Resource/Contents";
import { EditIncomeWithdrawalsInstructionStore } from "./Stores/Variable";
import { DrawdownType } from "../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import { IStepConfig } from "../../../../Shared/Process/Process/Process";
import { Confirmation } from "../../../../Shared/Process/Process/Confirmation";
import {
    AccountContextWizardComponent,
    IAccountContextWizardComponentState,
} from "../../../../Shared/Process/AccountContextWizardComponent";
import { RoutingActions } from "../../../../../react-core/Flux/Variables";
import { AccountRoleStore, ClientAccountStore } from "../../../Stroes/Variable";
import { getUrl } from "../PortfolioDashboard/Components/Common/PortfolioDashboardHelper";
import { StepType } from "../../../../Shared/Process/Process/Process";
import { processTypeEnum } from "../Common/Resource/Contents";
import { RestrictionStore } from "../Common/Restrictions/Variable";
import { SubAccountType } from "../../../../../Wrap/Constants/Enums/Domain/SubAccountType";import { Action } from "../../../Actions/Action";
import { DocumentsAndDeclarations } from "./Components/DocumentsAndDeclarations/DocumentsAndDeclarations";

interface IEditIncomeWithdrawalsWizardState extends IAccountContextWizardComponentState {
    extraInfo: any;
    firstFlag: boolean;
}
export class EditIncomeWithdrawalsWizard extends AccountContextWizardComponent<IEditIncomeWithdrawalsWizardState> {
    constructor(props: any) {
        super(props);
        this.subscribeToStore(EditIncomeWithdrawalsInstructionStore, () => this.onInstructionStoreChange());
    }

    initState() {
        this.state = {
            data: null,
            errorMsg: [],
            isShowErrorMsg: false,
            isLoading: true,
            onPosting: false,
            active: true,
            isSubmitting: false,
            customer: null,
            clientAccount: null,
            extraInfo: null,
            firstFlag: true,
        };
    }
    private onInstructionStoreChange() {
        const data = EditIncomeWithdrawalsInstructionStore.getData();
        this.setState({
            isLoading: false,
            data: data,
        });
    }

    componentDidMount() {
        super.componentDidMount();
        const params = getQueryParameters();

        Action.getBankAccounts(params["hierarchyid"], (result) => {
            this.setState({
                extraInfo: { AllBankAccounts: result, Drawdowntype: DrawdownType.Flexible },
            }); 
        });
    }

    componentDidUpdate(prevProps) {
        const { customer, clientAccount, firstFlag } = this.state;

        if (clientAccount && customer && !this.state.data && firstFlag) {
            this.setState({ firstFlag: false });
            const KeyOfInstructionId = "id"
            const id = getQueryParameters()[KeyOfInstructionId];
            const npr = clientAccount.SubAccounts.find((x) => x.SubAccountType == SubAccountType.Npr || x.SubAccountType == SubAccountType.JuniorSipp);
            if (npr) {
                this.setState({ isLoading: true }, () => {
                    EditIncomeWithdrawalsAction.getInstruction2(
                        id,
                        clientAccount.HierarchyId,
                        npr.HierarchyId,
                        customer.CustomerId,
                        (instructionId)=>{
                            this.setState({ isLoading: false });
                            if (instructionId) {
                                setQueryParametersWithoutRefresh(KeyOfInstructionId, instructionId)
                            }
                        }
                    );
                })
            }
        }
    }

    getStepProps(index) {
        const { active } = this.state;
        const stepProps = super.getStepProps(index);
        stepProps.isReview = !active;
        return stepProps;
    }

    setStepperConfig() {
        const type = Number(getQueryParameters()["type"]);
        const subAccountHierarchyId = getQueryParameters()["subaccounthierarchyid"];
        const { data, clientAccount } = this.state;
        const subAccount = clientAccount?.SubAccounts?.find((x) => x.HierarchyId == subAccountHierarchyId);

        const steppers: IStepConfig[] = [
            {
                title: EditIncomeWithdrawalsSteppersMap.incomePaymentDetails,
                url: Urls.get().EditIncomeWithdrawalsIncomePaymenDetails,
                path: Contents.URLMap.incomePayment,
                onStepLeave: (from: any, to: any) => {
                    const isRestrictionActive = RestrictionStore.WithdrawDisabled();
                    if (!isRestrictionActive) {
                        this.onStepperLeave(from, to);
                    }
                },
                component: <IncomePaymentDetails {...this.getStepProps(0)}
                    extraInfo={this.state.extraInfo}
                    processType={processTypeEnum.EditIncomePayments}
                    subAccountType={subAccount?.SubAccountType}
                    isLoading={this.state.isLoading}
                />,
            },            

            {
                title: EditIncomeWithdrawalsSteppersMap.review,
                url: Urls.get().EditIncomeWithdrawalsReview,
                path: Contents.URLMap.review,
                onStepLeave: (from: any, to: any) => {
                    this.onStepperLeave(from, to);
                },
                component: <Review {...this.getStepProps(1)} customerId={this.state.customer?.CustomerId} extraInfo={this.state.extraInfo} />,
            },

            {
                title: EditIncomeWithdrawalsSteppersMap.DocumentsAndDeclarations,
                url: Urls.get().EditIncomeWithdrawalsDocsAndDeclarations,
                path: Contents.URLMap.documentAndDeclarations,
                onStepLeave: (from: any, to: any) => {
                    this.onStepperLeave(from, to);
                },
                needPrint: true,
                onSubmit: () => this.onSubmit(),
                canSubmit: () => this.child[this.stepperConfig.length - 3].isValid(),
                component: <DocumentsAndDeclarations {...this.getStepProps(1)} customerId={this.state.customer?.CustomerId} extraInfo={this.state.extraInfo} />,
            },

            {
                title: EditIncomeWithdrawalsSteppersMap.confirm,
                url: Urls.get().EditIncomeWithdrawalsConfirmation,
                path: Contents.URLMap.confirmation,
                type: StepType.Confirmation,
                component: (
                    <Confirmation
                        onExit={() => this.onExit()}
                        successMessage={`We've successfully received your instruction to edit income payments for ${data?.ClientDetails?.FirstName} ${data?.ClientDetails?.LastName}.`}
                        isLoading={this.state.isSubmitting}
                    />
                ),
            },
        ];

        this.stepperConfig = steppers;
    }

    setProcessProps() {
        const type = Number(getQueryParameters()["type"]);
        const { data } = this.state;
        const processProps = super.setProcessProps();
        processProps.processTitle = "Edit income payments";
        processProps.subTitle = productMap[type];
        return processProps;
    }

    saveInstruction(from: any, to: any, toUrl: any, params: any, stepLength: any) {
        EditIncomeWithdrawalsAction.saveInstruction2(this.state.data, this.state?.customer?.CustomerId, (result) => {
            this.setState({ onPosting: false });
            if (result.length > 0) {
                this.setState({ errorMsg: result, isShowErrorMsg: true });
            } else {
                if (to == -1) {
                    this.onExit();
                } else {
                    Navigator.navigateTo(toUrl, {
                        queryParamsObject: params,
                        scrollAfterNavigating: true,
                    });
                }
            }
        });
    }
    onCancel() {
        this.onExit();
    }
    onExit() {
        const accountRoles = AccountRoleStore.getAccountRoles();
        const clientAccount = ClientAccountStore.getClientAccountInfo();
        RoutingActions.navigateTo(getUrl(clientAccount, accountRoles, "summary"));
    }
    onSubmit() {
        this.setState({ isSubmitting: true });

        EditIncomeWithdrawalsAction.submitInstruction(
            this.state.data.HierarchyId,
            this.state.data.Contribution,
            this.state.data.ClientDetails.ActorId,
            this.state.data.SubAccountClientDetail.ClAccountId, 
            () => this.setState({ active: false, isSubmitting: false })
        );
    }
}
